export const LoaderOptions = {
  position: 'absolute',
  top: 'calc(50% - 20px)',
  left: 'calc(50% - 15px)',
};
